import React, { useEffect, useRef ,useState} from 'react'
import FlashProduct from './FlashProduct';
import "./flashsale.css"
import {flashdata} from "../Products/flashproductdata"
import {useNavigate} from "react-router-dom"

function FlashSale() {
    const Ref = useRef(null);

    const [timer, setTimer] = useState('00:00:00');

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / 1000 / 60 / 60) % 24);
        return {
            total, hours, minutes, seconds
        }
    }

    const startTimer = (e) =>{
        let{total, hours, minutes, seconds} = getTimeRemaining(e);
        if(total >= 0){
            setTimer(
                (hours > 9 ? hours : '0' + hours) +':'+
                (minutes > 9 ? minutes : '0' + minutes) + ':' +
                (seconds > 9 ? seconds : '0' + seconds) 
            )
        }
    }

    const clearTimer = (e) => {
        setTimer('12:00:00');
        if(Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = id;
    }

    const getDeadTime = () =>{
        let deadLine = new Date();
        deadLine.setSeconds(deadLine.getSeconds() +43200);
        return deadLine;
    }

    useEffect(() =>{
        clearTimer(getDeadTime());
    })

    const navigate = useNavigate();

  return (
    <div className='flash-container'>
        <div className='flash-one'>
            <h3>On Sale Now</h3>
            <div>
                <h3>Ending in <span>{timer ==='00:00:00' ? "Time Up" : timer }</span></h3>
                <p onClick={() => navigate('/saleproduct')} >SHOP MORE</p>
            </div>
            
        </div>
        <div className='flash-two'>
            <FlashProduct  flashdata={flashdata} />
        </div>
    </div>
  )
}

export default FlashSale